var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCreatures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80%",
    height: "100%",
    fill: "#0067FF",
    viewBox: "0 0 80 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 60.2432C68 74.9459 57.6731 99.5 40 99.5C22.3269 99.5 13 74.5135 8 60.2432C8 44.9584 22.3269 33 40 33C57.6731 33 72 44.9584 72 60.2432Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5241 17.5C53.5241 27.165 47.9277 29.5 41.0241 29.5C34.1206 29.5 28.5241 27.165 28.5241 17.5C28.5241 12.5 34.4968 2 41.0241 0C47.4968 2 52.4968 13 53.5241 17.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9994 21.5C19.9994 31.165 22.9994 32 16.4994 37C1.99939 44 0 40.165 0 30.5C0 25.5 8.97205 12.5 15.4994 10.5C18.4994 16 18.9721 17 19.9994 21.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9897 21.5C59.9897 31.165 56.9898 32 63.4898 37C77.9898 44 79.9891 40.165 79.9891 30.5C79.9891 25.5 71.0171 12.5 64.4898 10.5C61.4898 16 61.0171 17 59.9897 21.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreatures);
export default __webpack_public_path__ + "static/media/icon-creatures.113fdb8650243c580380277e617be0e5.svg";
export { ForwardRef as ReactComponent };